import { createComponentWithProxy } from "react-fela";

import { expand } from "~/styleguide/utils";

export default function AspectContainer({ aspect = 9 / 16, className, html }) {
    return (
        <div style={{ position: "relative" }}>
            <Aspect
                className={className || "aspect-container"}
                aspect={aspect}
                dangerouslySetInnerHTML={{
                    __html: html
                }}
            ></Aspect>
        </div>
    );
}

const Aspect = createComponentWithProxy(
    ({ aspect }) => ({
        width: "100%",
        height: 0,
        paddingBottom: `${aspect * 100}%`,
        "> iframe": {
            ...expand()
        }
    }),
    "div"
);
